import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";

export default function TenantRechargeHistory() {
 const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
         const userId = useSelector((state)=>state?.user?.user?.user_id)
  const [loading, setLoading] = useState(false);
const [tenantId,setTenantId] =useState(userId)
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const limit = 10;
const [channel, setChannel] = useState("");
  const [status, setStatus] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    load();
  }, [page,channel,status,from,to]);

  async function load(p = page) {

    const params = new URLSearchParams({
      ...(channel ? { channel } : {}),
      ...(status ? { status } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),appToken:appToken,currentToken:currentToken,
      limit,tenantId,
      offset: p * limit
    });

    const r = await fetch(
      `${webUrlNode}/api/credits/tenant-recharges?${params.toString()}`,
      
    );

    const j = await r.json();
    setRows(j?.length?j : []);
  }
function StatusBadge({ status }) {
  const colors = {
    created: "#f59e0b",
    paid: "#10b981",
    failed: "#ef4444"
  };

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: colors[status] + "20",
        color: colors[status],
        textTransform: "capitalize"
      }}
    >
      {status}
    </span>
  );
}
  return (
  <div style={styles.wrapper}>

      <h2 style={styles.heading}>Recharge History</h2>

      {/* Filters */}
      <div style={styles.filterCard}>
        <select
          style={styles.input}
          value={channel}
          onChange={e => setChannel(e.target.value)}
        >
          <option value="">All channels</option>
          <option value="email">Email</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="push">Push</option>
          <option value="ai">AI</option>
        </select>

        <select
          style={styles.input}
          value={status}
          onChange={e => setStatus(e.target.value)}
        >
          <option value="">All status</option>
          <option value="created">Created</option>
          <option value="paid">Paid</option>
          <option value="failed">Failed</option>
        </select>

        <input
          type="date"
          style={styles.input}
          value={from}
          onChange={e => setFrom(e.target.value)}
        />

        <input
          type="date"
          style={styles.input}
          value={to}
          onChange={e => setTo(e.target.value)}
        />
      </div>

      {/* Desktop Table */}
      <div className="desktopTable" style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Channel</th>
              <th>Pack</th>
              <th>Credits</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map(r => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>{r.channel}</td>
                <td>{r.packName || "-"}</td>
                <td>{r.credits}</td>
                <td>₹{(r.amountPaise/100).toFixed(2)}</td>
                <td><StatusBadge status={r.status} /></td>
                <td>{new Date(r.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="mobileCardsRechargeHistory" style={styles.mobileContainer}>
        {rows?.map(r => (
          <div key={r.id} style={styles.mobileCard}>
            <div style={styles.mobileHeader}>
              <strong>₹{(r.amountPaise/100).toFixed(2)}</strong>
              <StatusBadge status={r.status} />
            </div>

            <div style={styles.mobileRow}>
              <span>Channel:</span> {r.channel}
            </div>

            <div style={styles.mobileRow}>
              <span>Credits:</span> {r.credits}
            </div>

            <div style={styles.mobileRow}>
              <span>Date:</span>{" "}
              {new Date(r.createdAt).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div style={styles.pagination}>
        <button
          disabled={page === 0}
          style={styles.pageBtn}
          onClick={() => setPage(p => Math.max(0, p - 1))}
        >
          ← Prev
        </button>

        <button
          style={styles.pageBtn}
          onClick={() => setPage(p => p + 1)}
        >
          Next →
        </button>
      </div>

      {/* Responsive CSS */}
      <style>
        {`
        
table th {background:#f9f9f9; padding:10px}
         
table td {background:#ffffff; padding:10px}
         
        /* xs */
@media (max-width: 767px) { 
             .desktopTable{
              display: none !important;
            }
          }

          
/* lg */ 
@media (min-width: 1200px) {.mobileCardsRechargeHistory  {
              display: none !important;
            }
          }
/* md */
@media (min-width: 992px) and (max-width: 1199px) { .mobileCardsRechargeHistory  {
              display: none  !important;
            }
          }
/* sm */
@media (min-width: 768px) and (max-width: 991px) { .mobileCardsRechargeHistory {
              display: none  !important;
            }
          }
        `}
      </style>

    </div>
  );
}
const styles = {
  wrapper: {
    padding: 20,
    background: "#f8fafc",
    
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 20
  },

  filterCard: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    marginBottom: 20,
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
  },

  input: {
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #e5e7eb"
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%", textAlign: "center",
    borderCollapse: "collapse"
  },
  

  mobileContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },

  mobileCard: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
  },

  mobileHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10
  },

  mobileRow: {
    fontSize: 14,
    marginBottom: 4
  },

  pagination: {
    marginTop: 20,
    display: "flex",
    gap: 10
  },

  pageBtn: {
    padding: "8px 14px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  }
};